<template>

    <m-edit1/>

    <m-factor-500 v-bind='{...{"showProductFeatures":"true"},...{}}' :style='""' class="" ></m-factor-500>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor500 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor500';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor500 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
